import React from 'react';

type MutableRefTypes<T> =
  | React.MutableRefObject<T | null>
  | React.RefCallback<T>
  | undefined
  | null;

export function setRef<T>(ref: MutableRefTypes<T>, node: T | null) {
  if (!ref) {
    return;
  }

  if (typeof ref === 'function') {
    ref(node);
    return;
  }

  ref.current = node;
}

export function setRefs<T>(refs: MutableRefTypes<T>[], node: T | null) {
  refs.forEach(ref => setRef(ref, node));
}
